export default __webpack_public_path__ + "static/media/zelda.ef9494f2.mp3";